export const emptySetTitle = 'No live images';
export const emptySetDescription =
	'Uploaded files will be automatically converted to progressive JPGs for better web viewing, then added to this services listing and delivered to the client.';
